export const listCopyFr = {
    published: "Publié",
    draft: "Brouillon",
    name: "Nom",
    role: "Rôle",
    organisation: "Organisation",
    email: "E-mail",
    dateOfBirth: "Date de naissance",
    labels: "Étiquettes",
    status: "Statut",
    actions: "Actions",
};
